<div class="purgeDialog">
    <sync-dialog
        [config]="{title: 'Purge', subTitle: subTitle, isClosable: false, actionButton: batchView.spinner ? '' : 'Purge', cancelButton: 'Cancel',onActionClick: purgeFiles,onCancelClick: closeDialog}"
        [open]="showDialog" [isFullScreen]="false" [onClose]="closeDialog" [isCritical]="true">
        <div class="dialog-purge-container">
            <sync-alert *ngIf="batchView.spinner" type="warning" [showLeadIcon]="true" leadIcon="warning"
                title="Do not close this window or your web browser."
                description="Please wait until the operation has completed successfully." [showActions]="false"
                [showPrimaryAction]="false" [showSecondaryAction]="false" [showCloseButton]="false"></sync-alert>
            <sync-spinner *ngIf="batchView.spinner"></sync-spinner>
            <ng-container *ngIf="!batchView.spinner">
                <ng-container *ngIf="purgeItems.length === 1">
                    Are you sure you want to purge this item? It will be permanently deleted.
                </ng-container>
                <ng-container *ngIf="purgeItems.length > 1">
                    Are you sure you want to purge these items? They will be permanently deleted.
                </ng-container>
            </ng-container>
            <ng-container *ngIf="batchView.spinner">
                <ng-container *ngFor="let item of purgeItems
                | orderBy: '[type,search_name]':false">
                    <div *ngIf="batchView.spinner === item.sync_id"
                        class="processing body-bold-1">
                        Processing {{ item.name }} - {{ batchView.percent }}%
                    </div>
                </ng-container>
            </ng-container>
        </div>

    </sync-dialog>
</div>